"use client";
import ProductCard from "@/components/ProductCard/ProductCard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useRef } from "react";

import "swiper/css/free-mode";
import "swiper/css/thumbs";
import { FreeMode, Thumbs, Navigation } from "swiper/modules";
import "swiper/css/navigation";
import { useSession } from "@/hooks/useSession";

const ProductSimilar = ({ item, t }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { session } = useSession();
  return (
    <div className="otherProducts">
      <div className="subTitle">
        <span>{t["forms.similar_products"]}</span>
      </div>
      <div className="otherSwiper">
        <button ref={prevRef} className="swiper-button-prev"></button>
        <button ref={nextRef} className="swiper-button-next"></button>
        <Swiper
          spaceBetween={20}
          slidesPerView={4}
          onSwiper={(swiper) => {
            setTimeout(() => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
              swiper.navigation.init();
              swiper.navigation.update();
            });
          }}
          modules={[Navigation]}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          breakpoints={{
            320: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            640: {
              slidesPerView: 3.2,
            },
            991: {
              slidesPerView: 4,
            },
          }}
        >
          {item?.length > 0
            ? item?.map((similar) => (
                <SwiperSlide key={similar.id}>
                  <ProductCard
                    item={similar}
                    t={t}
                    isAuthenticated={!!session}
                  />
                </SwiperSlide>
              ))
            : null}
        </Swiper>
      </div>
    </div>
  );
};

export default ProductSimilar;
